import $ from 'jquery';

export default class Audio {
  constructor() {
    let that = this;

    /**
    * @name audio-play
    * @function
    * @param {data}
    * @description: Event listener for play the audio
    */
    $(document).bind('audio-play', function (e, audio) {
      if (audio.autoPlay || audio.start) {
        let audioElm = document.getElementById('chessAudio'),
          volControl = (audio.controls === false) ? false : true;

        $('#chessAudio').attr('src', audio.src);
        $('#chessAudio').attr('loop', audio.loop);

        if (volControl) {
          $('.volume-control').html('<span class="volume-icon volume"></span>')
        }

        audioElm.muted = false;
      } else if (audio.stop) {
        $(document).trigger('audio-pause');
      }

      $('#chessAudio').on('ended', function () {
        if (!audio.loop) {
          $(document).trigger('audio-pause');
        }

        $("#chessAudio").unbind('ended');
      })
    }).bind(that);

    /**
    * @name audio-pause
    * @function
    * @param {data}
    * @description: Event listener for pause the audio
    */
    $(document).bind('audio-pause', function (e, data) {
      $('#chessAudio').removeAttr('loop');
      if ($('#chessAudio')[0]) {
        $('#chessAudio')[0].pause();
      }

      $('.volume-icon').remove();
    }).bind(that);

    /**
    * @name
    * @function
    * @param {}
    * @description: Event listener for volume icon
    */
    $(document).on('click', '.volume-icon', function (e) {
      let audioElm = document.getElementById('chessAudio');

      audioElm.muted = !audioElm.muted;
      $(this).toggleClass("volume mute");
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/audio.js